(function(){
  var END=new Date("2026-03-08T23:59:59+01:00").getTime();
  function pad(n){return n<10?"0"+n:n}
  function getCountdown(){
    var d=END-Date.now();
    if(d<=0) return null;
    var days=Math.floor(d/86400000);
    var hrs=Math.floor((d%86400000)/3600000);
    var mins=Math.floor((d%3600000)/60000);
    var secs=Math.floor((d%60000)/1000);
    return days+"d "+pad(hrs)+"h "+pad(mins)+"m "+pad(secs)+"s";
  }
  /* Inject countdown into announcement bar */
  function initAnnouncement(){
    var els=document.querySelectorAll(".announcement-bar__text");
    els.forEach(function(el){
      if(el.textContent.indexOf("PROMO")>-1 || el.textContent.indexOf("promo")>-1){
        var span=document.createElement("span");
        span.className="cd-timer";
        span.style.cssText="font-weight:700;letter-spacing:0.04em;margin-left:6px;";
        el.appendChild(document.createTextNode(" — Ends in "));
        el.appendChild(span);
      }
    });
  }
  function update(){
    var txt=getCountdown();
    document.querySelectorAll(".cd-timer").forEach(function(el){
      el.textContent=txt||"PROMO ENDED";
    });
  }
  function start(){initAnnouncement();update();setInterval(update,1000)}
  if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",start)}
  else{start()}
})();